import { render, staticRenderFns } from "./video.vue?vue&type=template&id=a47d2424&scoped=true&"
var script = {}
import style0 from "./video.vue?vue&type=style&index=0&id=a47d2424&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47d2424",
  null
  
)

export default component.exports